import {h, Fragment} from "preact"
import { useActions, useAppState, useProductFilters } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import { defaultConfig, sortOptions } from '../config'

import Sidebar from './Sidebar'
import SelectedFilters from "./SelectedFilters"

export default ({ mobile, setShowFilters, showFilters, handleClickFilters }) => {
    const { loading, query, response, pageType } = useAppState()
    const { updateSearch } = useActions()
    const { filters } = useProductFilters()
    
    const [currentSort, setCurrentSort] = useState(sortOptions[0].value.name);
    const [showDropdown, setShowDropdown] = useState(false);
    const [filterHeading, setFilterHeading] = useState("Filter Selection");

    const docCount = response.products?.total ?? 0;

    const facets = response.products?.facets ?? {};

    const isMobile = window.outerWidth < 768 ? true : false;

    const handleClickDropddown = () => {
        setShowDropdown(!showDropdown);
    }

    const handleDropdownButtonKeyDown = (event) => {
        switch (event.key) {
            case 'Enter':
            case ' ':
                event.preventDefault();
                setShowDropdown(!showDropdown);
                break;
            case 'ArrowDown':
                event.preventDefault();
                setShowDropdown(true);
                // Focus the first dropdown option
                document.getElementById(`sort-dropdown-option-desktop-${sortOptions[0].value.name}`).focus();
                break;
            case 'Escape':
                event.preventDefault();
                setShowDropdown(false);
                break;
            default:
                break;
        }
    }

    const handleDropdownOptionKeyDown = (event, index) => {
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                const nextIndex = (index + 1) % sortOptions.length;
                // Focus next option in the dropdown
                document.getElementById(`sort-dropdown-option-desktop-${sortOptions[nextIndex].value.name}`).focus();
                break;
            case 'ArrowUp':
                event.preventDefault();
                // Focus previous option in the dropdown
                const prevIndex = (index - 1 + sortOptions.length) % sortOptions.length;
                document.getElementById(`sort-dropdown-option-desktop-${sortOptions[prevIndex].value.name}`).focus();
                break;
            case 'Enter':
                event.preventDefault();
                handleDropdownOptionClick(sortOptions[index]);
                break;
            case 'Escape':
                event.preventDefault();
                setShowDropdown(false);
                // Return focus to the dropdown button
                document.getElementById('sort-dropdown-button-desktop').focus();
                break;
            default:
                break;
        }
    }

    const handleDropdownOptionClick = (option) => {
        updateSearch({
            products: {
                sort: sortOptions.find(v => v.id === option.id)?.value?.sort,
            },
        });
        setCurrentSort(option.value.name);
        setShowDropdown(false);
    }

    const handleize = (string) => {
        return string.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");;
    }

    useEffect(() => {
        if (filters.length > 0) {
            setFilterHeading("Edit Filters")
        } else {
            setFilterHeading("All Filters")
        }
    }, [filters])

    // useEffect(()=>{
    //     if(window.outerWidth > 768){
    //         jQuery(".ns-mobile-header-controls").remove();
    //     } else {
    //         jQuery(".ns-header-controls").remove();
    //     }
    // })

    // HORIZONTAL FILTERS LAYOUT (WRIKE TICKET ID 1628319696)
    let orderedFacets = facets;

    const customOrder = ["Size", "Color", "Collaborations", "Price", "Category", "Age", "Availability"];

    orderedFacets = facets?.slice().sort((a, b) => {
        return customOrder.indexOf(a.name) - customOrder.indexOf(b.name);
    });

    return (
        <div class="ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2">
            <div
                class={
                    mobile
                    ? 'collection-toolbar collection-toolbar--mobile'
                    : 'collection-toolbar collection-toolbar--desktop'
                }
                style={
                    loading ? 'opacity: 0.3;' : ''
                }
            >
                <div class="collection-toolbar__col collection-toolbar__col--filters">
                    <div class="collection-toolbar__filters">
                        <a href="javascript:void(0)" class="collection-toolbar__filters-button collection-toolbar__filters-button--all" aria-label="Open all filters" tabindex="0" onClick={(event) => {event.preventDefault(); handleClickFilters(null)}}>{filterHeading}</a>

                        {orderedFacets?.length > 0 
                            ? (
                                orderedFacets?.map((facet, index) => {
                                    const selectedCount = filters.filter(f => f.field === facet.field).length;

                                    return (
                                        <a class="collection-toolbar__filters-button" aria-label={`Open ${facet.name} filter`} tabindex="0" onClick={(event) => {event.preventDefault(); handleClickFilters(facet)}}>{facet.name}{selectedCount ? ` (${selectedCount})` : ''}</a>
                                    )
                                })
                            )
                            : ''
                        }
                    </div>

                    <div class="collection-toolbar__filters collection-toolbar__filters--selected">
                        <SelectedFilters/>
                    </div>
                </div>

                <div class="collection-toolbar__col collection-toolbar__col--sorting">
                    <div class="collection-toolbar__sorting">
                        <span 
                            class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-align-self-md-center ns-color-grey-dark"
                            data-nosto-element="totalResults"
                            aria-live="polite"
                            style="white-space: nowrap"
                        >
                            {docCount} products
                        </span>

                        <div class="ns-relative js-select-combobox sort-dropdown">
                            <span style="font-weight: 600" id={mobile ? "sort-dropdown-heading-mobile" : "sort-dropdown-heading-desktop"} class="combo-label">Sort By:</span>
                            <button
                                id={!mobile ? "sort-dropdown-button-desktop" : "sort-dropdown-button-mobile"} 
                                class="link-dropdown__button notabutton"
                                role="combobox"
                                aria-expanded={showDropdown ? "true" : "false"}
                                aria-live="polite"
                                aria-controls={!mobile ? "sort-dropdown-options-desktop" : "sort-dropdown-options-mobile"} 
                                aria-labelledby={mobile ? "sort-dropdown-heading-mobile" : "sort-dropdown-heading-desktop"}
                                aria-haspopup="listbox"
                                style="width: auto" 
                                onClick={handleClickDropddown}
                                onKeyDown={handleDropdownButtonKeyDown}
                                aria-activedescendant={!mobile ? `sort-dropdown-option-desktop-${handleize(currentSort)}` : `sort-dropdown-option-mobile-${handleize(currentSort)}`} 
                            >
                                <span class="link-dropdown__button-text" aria-live="polite">{currentSort}</span>
                            </button>

                            <ul id={!mobile ? "sort-dropdown-options-desktop" : "sort-dropdown-options-mobile"} class={!showDropdown ? "link-dropdown__options" : "link-dropdown__options open"} role="listbox" aria-labelledby={mobile ? "sort-dropdown-heading-mobile" : "sort-dropdown-heading-desktop"}>
                                {sortOptions.map((o, index) => (
                                    <li 
                                        role="option" 
                                        key={o.id} 
                                        aria-selected={o.value.name === currentSort}
                                        id={!mobile ? `sort-dropdown-option-desktop-${handleize(o.value.name)}` : `sort-dropdown-option-mobile-${handleize(o.value.name)}`}
                                        tabIndex="0"
                                        onClick={() => handleDropdownOptionClick(o)} 
                                        onKeyDown={(event) => handleDropdownOptionKeyDown(event, index)}
                                        className="link-dropdown__link"
                                    >
                                        {o.value.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
